import React, { useEffect, useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { Nav, Spinner } from 'react-bootstrap';

import UserService, { UserItem } from '#/services/UserService';

export const UserContext = React.createContext<{
  userInfo: null | UserItem | undefined;
  setUserInfo: (userInfo: UserItem | null | undefined) => void;
}>({
  userInfo: null,
  setUserInfo: (_: UserItem | null | undefined) => {},
});

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState<UserItem | null>();
  const [login, setLogin] = useState<boolean>();

  // ユーザ情報を取得する
  useEffect(() => {
    if (login !== undefined) {
      return;
    }

    new UserService().getUser().then((res) => {
      setUserInfo(res);
    });
  }, [login]);

  // ログイン済み判定を実施
  useEffect(() => {
    if (userInfo === undefined) {
      return;
    }

    if (userInfo == null) {
      setLogin(false);
    } else {
      setLogin(true);
    }
  }, [userInfo]);

  if (location.pathname === '/' && login === true) {
    navigate('/dashboard');
  }

  if (login === false) {
    navigate('/login', { replace: true });
  }

  if (login === undefined || !userInfo) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else if (login === false) {
    return <></>;
  }

  const navi = [
    {
      role: ['admin', 'user'],
      link: '/dashboard',
      name: 'ダッシュボード',
      icon: 'bi-activity',
    },
    {
      role: ['admin', 'user'],
      link: '/notification',
      name: '通知履歴',
      icon: 'bi-bell',
    },
    {
      role: ['admin'],
      link: '/owner',
      name: '親機',
      icon: 'bi-wifi',
    },
    {
      role: ['admin', 'user'],
      link: '/child',
      name: '子機',
      icon: 'bi-phone',
    },
    {
      role: [],
      link: '/admin',
      name: '管理者',
      icon: 'bi-person-square',
    },
    {
      role: ['admin'],
      link: '/user',
      name: 'ユーザ',
      icon: 'bi-person-circle',
    },
    {
      role: ['admin'],
      link: '/operation',
      name: '操作ログ',
      icon: 'bi-arrows-move',
    },
  ];

  const drawNavi = (link: string, name: string, icon: string = 'bi-activity') => {
    const attr =
      location.pathname.indexOf(link) === 0
        ? { active: true, 'aria-current': true }
        : {};
    return (
      <Nav.Link {...attr} className="nav-link" href={link} key={link}>
        <div className="nav-link-icon"><i className={icon}></i></div>
        {name}
      </Nav.Link>
    );
  };

  const drawDropMenu = (link: string, name: string) => {
    return (
      <a className="dropdown-item" href={link}>
        <div className="dropdown-item-icon"><i data-feather="log-out"></i></div>
        {name}
      </a>
    )
  };

  return (
    <>
      <nav className="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light bg-white" id="sidenavAccordion">
        <button className="btn btn-icon btn-transparent-dark order-1 order-lg-0 me-2 ms-lg-2 me-lg-0" id="sidebarToggle" onClick={event=>{
          event.preventDefault();
          document.body.classList.toggle('sidenav-toggled');
        }}><i className="bi-list"></i></button>
        <a className="navbar-brand pe-3 ps-4 ps-lg-2" href="/">AGtech</a>
        <ul className="navbar-nav align-items-center ms-auto">
          <li className="nav-item dropdown no-caret dropdown-user me-3 me-lg-4">
            <a className="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="/" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img className="img-fluid" src="/assets/images/profile-1.png" alt="prof" /></a>
            <div className="dropdown-menu dropdown-menu-end border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
              <h6 className="dropdown-header d-flex align-items-center">
                <img alt="dropprof" className="dropdown-user-img" src="assets/images/profile-1.png" />
                <div className="dropdown-user-details">
                  <div className="dropdown-user-details-name">{userInfo!.name}</div>
                  <div className="dropdown-user-details-email">{userInfo!.email}</div>
                </div>
              </h6>
              <div className="dropdown-divider"></div>
              {drawDropMenu('/logout', 'ログアウト')}
            </div>
          </li>
        </ul>
      </nav>
      <div id="layoutSidenav">
        <div id="layoutSidenav_nav">
          <nav className="sidenav shadow-right sidenav-light">
            <div className="sidenav-menu">
              <div className="nav accordion" id="accordionSidenav">
                <div className="sidenav-menu-heading">MENU</div>
                {navi
                    .filter((nav) => {
                      if (userInfo!.role! === 'superuser') {
                        return true;
                      }

                      return nav.role.includes(userInfo!.role!);
                    })
                    .map((nav) => {
                      return drawNavi(nav.link, nav.name, nav.icon);
                    })
                }
              </div>
            </div>
            <div className="sidenav-footer">
              <div className="sidenav-footer-content">
                <div className="sidenav-footer-subtitle">Logged in as:</div>
                <div className="sidenav-footer-title">{userInfo!.name}</div>
              </div>
            </div>
          </nav>
        </div>
        <div id="layoutSidenav_content" onClick={()=>{
          const BOOTSTRAP_LG_WIDTH = 992;
          if (window.innerWidth >= BOOTSTRAP_LG_WIDTH) {
            return;
          }
          if (document.body.classList.contains("sidenav-toggled")) {
            document.body.classList.toggle("sidenav-toggled");
          }
          }}>
          <main>
            <UserContext.Provider value={{ userInfo, setUserInfo }}>
              <Outlet />
            </UserContext.Provider>
          </main>
          <footer className="footer-admin mt-auto footer-light">
            <div className="container-xl px-4">
              <div className="row">
                <div className="col-md-6 small">Copyright &copy; agtech 2022</div>
                <div className="col-md-6 text-md-end small">
                  <a href="#!">Privacy Policy</a>
                  &middot;
                  <a href="#!">Terms &amp; Conditions</a>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
}

export default App;
